export const LocalStorageKeys = {
  TOKEN: 'token',
  I18_NEXT_LNG: 'i18nextLng',
}
